/**
 * @author Yash Soni
 */
import { __assign } from "tslib";
/* eslint import/prefer-default-export: 0 */
// TODO: Grab breakpoints from theme
var breakpoints = {
    small: 670,
    medium: 920,
    large: 1280,
};
var responsiveTheme = Object.keys(breakpoints).reduce(function (acc, key) {
    acc.mediaQuery[key] = "@media screen and (min-width: ".concat(breakpoints[key], "px)");
    return acc;
}, {
    breakpoints: breakpoints,
    mediaQuery: {},
});
export var withResponsiveTheme = function (theme) { return (__assign(__assign({}, theme), responsiveTheme)); };
